import type { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Chip } from '@mint-lib/tw-components';

import type { SuggestionGridType } from '../../../../types/suggestion.js';

const ChipCell = (params: ICellRendererParams<SuggestionGridType>) => {
  if (!params.valueFormatted) {
    return null;
  }
  return (
    <Chip variant="outline" className="hover:bg-transparent">
      {params.valueFormatted}
    </Chip>
  );
};

export { ChipCell };
